import React, { useEffect, useState } from 'react';
import useExtendedEffect from '../../../../utilities/hooks/useExtendedEffect';
import useEffectAsync from '../../../../utilities/hooks/useEffectAsync';
import { connect } from 'react-redux';
import { goToPage, setSelectedSubscriber, setErrorPage, reportDWH, reportAnalytics } from '../PremiumPackagesCatalogSlice';
import { getCatalogAsync } from '../premiumPackagesCatalogAsyncThunk';
import SubscriberList from '../Partials/subscriberList/subscriberList';
import Footer from '../Partials/footer/footer';

const SubscriberListPage = (props) => {
  const [error, setError] = useState('');

  useExtendedEffect((runSideEffects) => {
    props.reportDWH({ actionType: 'GetTvUsers', status: 'Ongoing', messageText: 'TV Users Displayed' });
    props.reportAnalytics({
      eventCategory: 'premium_packages',
      eventAction: 'visibility_1',
      eventLabel: 'element_1',
    });
    if (runSideEffects()) {
    }
  }, []);

  let isDisplayFooter = true;
  let btnText = 'המשך';
  let currentPageFunction = handlePageContinue;
  let formid = 'premiumPackagesCatalogForm';

  let purpleTitle = "";
  let boldTitle1 = "";
  let boldTitle2 = "";
  let extraBoldTitle1 = "איזה כיף!";
  let extraBoldTitle2 = `יש לכם כמה מנויי ${window.Config.brand_Name_HE} TV`;
  let subTitle = "על איזה מנוי תרצו לבצע את הפעולה?"

  let currentPageHeadline = (
    <div className='page-headline-wrapper'>
      {purpleTitle && <h1 className='purple-title'>{purpleTitle}</h1>}
      {boldTitle1 && <h2 className='bold-title1'> {boldTitle1} </h2>}
      {boldTitle2 && <h2 className='bold-title2'> {boldTitle2} </h2>}
      {extraBoldTitle1 && <h3 className='extra-bold-title'> {extraBoldTitle1}<br />{extraBoldTitle2} </h3>}
      {subTitle && <h4 className='sub-title'> {subTitle} </h4>}
    </div>

  );

  let currentPageView = (<SubscriberList errorText={error} subscribers={props.tvSubscribers} selectedSubscriber={props.selectedSubscriber} onSelectedSubscriber={handleOnSelectedSubscriber} />);

  return (
    <div>
      {currentPageHeadline}
      <div className='premium-packages-catalog-content'>
        <form noValidate id={formid} onSubmit={handleSubmit}>
          {currentPageView}
        </form>
      </div>
      <Footer isDisplayFooter={isDisplayFooter} btnText={btnText} onclick={props.isStreamingRedirect || props.isHboRedirect ? null : currentPageFunction} formid={formid} />
    </div>
  );

  function handleOnSelectedSubscriber(subscriber) {
    props.setSelectedSubscriber(subscriber);
    props.reportAnalytics({
      eventCategory: 'premium_packages',
      eventAction: 'click_1',
      eventLabel: 'element_2',
    });
  }

  function handlePageContinue() {
    if (!props.selectedSubscriber) {
      setError('אנא בחר מנוי');
      return;
    }

    setError('');
    if (!props.selectedSubscriber?.isJetCustomer) {
      props.setErrorPage({ isDisplay: true, id: '0', type: 'isNotJetCustomer', isOpenWorkOrder: true, description: 'is jet customer' })
    }
    else if (!props.selectedSubscriber?.isActive) {
      props.setErrorPage({ isDisplay: true, id: '0', type: 'notAllowed', isOpenWorkOrder: true, description: 'not allowed' })
    }
    else if (props.selectedSubscriber.hasDebt && props.selectedSubscriber.hasPaymentMethodIssue) {
      props.setErrorPage({ isDisplay: true, id: '0', type: 'hasDebtAndHasPaymentMethodIssue', isOpenWorkOrder: true, description: 'has debt and has payment method issue' });
    }
    else if (props.selectedSubscriber.hasDebt) {
      props.setErrorPage({ isDisplay: true, id: '0', type: 'hasDebt', isOpenWorkOrder: true, description: 'has debt' });
    }
    else if (props.selectedSubscriber.hasPaymentMethodIssue) {
      props.setErrorPage({ isDisplay: true, id: '0', type: 'hasPaymentMethodIssue', isOpenWorkOrder: true, description: 'has payment method issue' });
    }
    else {
      props.getCatalogAsync();
    }
  }

  function handleSubmit(event) {
    event.preventDefault();
    props.onSubmit?.(props.selectedSubscriber);
  }


};

const mapStateToProps = (state) => {
  return {
    tvSubscribers: state.premiumPackagesCatalog.tvSubscribers,
    selectedSubscriber: state.premiumPackagesCatalog.selectedSubscriber,
  };
};

const mapDispatchToProps = {
  goToPage,
  setErrorPage,
  reportDWH,
  reportAnalytics,
  setSelectedSubscriber,
  getCatalogAsync
};

export default connect(mapStateToProps, mapDispatchToProps)(SubscriberListPage);
